import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  constructor(private readonly http: HttpClient) {}

  getAccessKey(): Observable<string> {
    return this.http.get<string>('api/host/authorization/access-key', {
      headers: { 'hide-errors': 'true' },
    });
  }

  revokeAccessKey(): Observable<void> {
    return this.http.delete<void>('api/host/authorization/access-key', {
      headers: { 'hide-errors': 'true' },
    });
  }
}
